/**
 * パスワード再設定フォームの表示切替。
 *
 * href="#recover" のネイティブなアンカー遷移に任せると、:target のスクロールで
 * ページが動く。このページは可動スクロール量が固定ヘッダーアイコン
 * (.bottom-nav) の分しかないため、その動きでコンテンツがアイコンの下へ潜り込む。
 * クリックは preventDefault して状態 class で切り替え、URL のハッシュだけ
 * replaceState で合わせる。JS が無効な場合は CSS の :target 側で切り替わる。
 */
(function () {
  var RECOVER_HASH = '#recover';
  var STATE_CLASS = 'is-recover';

  document.addEventListener('DOMContentLoaded', function () {
    var authPage = document.querySelector('.auth-page');
    if (!authPage) return;

    var trigger = authPage.querySelector('a[href="' + RECOVER_HASH + '"]');
    if (!trigger) return;

    // /account/login#recover への直接アクセス・リロード。
    // この場合は :target フォールバック CSS が読み込み時点で効くため、
    // ブラウザのフラグメントスクロールが走ってしまう。位置を戻しておく。
    if (window.location.hash === RECOVER_HASH) {
      authPage.classList.add(STATE_CLASS);

      var resetScroll = function () {
        window.scrollTo(0, 0);
      };
      resetScroll();
      window.addEventListener('load', resetScroll, { once: true });
    }

    trigger.addEventListener('click', function (event) {
      event.preventDefault();
      authPage.classList.add(STATE_CLASS);

      if (window.location.hash !== RECOVER_HASH) {
        window.history.replaceState(null, '', RECOVER_HASH);
      }

      // 見出しは tabindex="-1" を持つのでフォーカスを移せる。
      // preventScroll でスクロールは発生させない。
      var heading = document.getElementById('recover');
      if (heading) heading.focus({ preventScroll: true });
    });
  });
})();
